
import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
}

export default function Card({ children, className = '', hover = false }: CardProps) {
  const hoverClasses = hover ? 'hover:bg-gray-800 hover:scale-105 transition-all duration-300' : '';
  
  return (
    <div className={`bg-gray-900 border border-gray-700 rounded-xl p-6 ${hoverClasses} ${className}`}>
      {children}
    </div>
  );
}
